export default __webpack_public_path__ + "static/media/image3.8387f3ff.svg";